// **Zona para o vídeo player

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import VideoLibraryLesson from "./VideoLibraryLesson";
import TextLesson from "./TextLesson";
import AudioLesson from "./AudioLesson";
import VideoLesson from "./VideoLesson";
import Button from "@mui/material/Button";
import ChevronRight from "mdi-material-ui/ChevronRight";
import CheckCircleOutline from "mdi-material-ui/CheckCircleOutline";
import TextBoxOutline from "mdi-material-ui/TextBoxOutline";
import ClockOutline from "mdi-material-ui/ClockOutline";
import Box from "@mui/material/Box";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment/moment";
import NoVideo from "./NoVideo";
import QuestionnaireLesson from "./QuestionnaireLesson";
import { isNil } from "@salespark/toolkit";
import { locale } from "src/lang/locale/moment_pt_PT";

moment.locale("pt", locale);
const avaliableSoonLessonImage = "/images/avaliable-soon.png";

const DoesntContainVideo = () => {
  return (
    <div className="lesson-state">
      <div className="lesson-state__icon">
        <TextBoxOutline />
      </div>
      <h3 className="lesson-state__title">Aula de leitura</h3>
      <p className="lesson-state__text">Esta aula é em formato de texto. Podes ler o conteúdo completo aqui em baixo, na secção Detalhes.</p>
    </div>
  );
};

const ChapterAvaliableIn = ({ chapter, courseAddedAt, courseEndDate, hasTeaserAccess = false }) => {
  if (!chapter) return <></>;
  const chapterStatusCode = Number(chapter.status_code);
  if (chapterStatusCode === 5 || chapterStatusCode === 6) return <></>;
  if (hasTeaserAccess === true && chapter.teaser_locked === true) {
    return (
      <>
        <h2 className="lesson-soon__title">Não disponível na versão gratuita</h2>
        <p className="lesson-soon__hint">Adquire a versão completa do curso para desbloquear este módulo.</p>
      </>
    );
  }

  if (chapterStatusCode === 1) return <></>;
  let fromNow = undefined;
  let availableAt = undefined; // the actual availability date, for the DD-MM-YYYY hint

  // Dripping
  if (chapterStatusCode === 2 && chapter.drip_days !== undefined) {
    const avaliableDate = moment.utc(courseAddedAt).add(chapter.drip_days, "days");
    if (moment.utc().isAfter(avaliableDate)) return <></>;

    fromNow = moment.utc(avaliableDate).fromNow(true);
    availableAt = avaliableDate;
  }

  // Avaliable On
  if (chapterStatusCode === 3 && chapter.avaliable_on !== undefined) {
    if (moment.utc().isAfter(chapter.avaliable_on)) return <></>;

    fromNow = moment.utc(chapter.avaliable_on).fromNow(true);
    availableAt = moment.utc(chapter.avaliable_on);
  }

  if (chapter.avaliable_on !== undefined && chapter.avaliable_on !== null) {
    // Check if difference is less than 1 mounth
    if (moment.utc().diff(moment.utc(chapter.avaliable_on), "days") < 30) {
      return (
        <>
          <h2 className="lesson-soon__title">Módulo disponível dentro de</h2>
          <Countdown date={moment.utc(chapter.avaliable_on).local().toDate()} renderer={renderer} />
          <p className="lesson-soon__hint">Este módulo fica disponível automaticamente quando a contagem terminar.</p>
        </>
      );
    }
  }
  if (fromNow !== undefined) {
    return (
      <>
        <h2 className="lesson-soon__title">{`Módulo disponível dentro de ${fromNow}`}</h2>
        <p className="lesson-soon__hint">{`Este módulo fica disponível automaticamente na data prevista (${moment.utc(availableAt).local().format("DD-MM-YYYY")}).`}</p>
      </>
    );
  }
  return (
    <>
      <h2 className="lesson-soon__title">Módulo ainda não disponível</h2>
      <p className="lesson-soon__hint">Assim que for disponibilizado, poderás aceder ao conteúdo deste módulo aqui.</p>
    </>
  );
};

const renderer = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="countdown-v3">
      <div className="countdown-v3__unit">
        <span className="countdown-v3__num">{days}</span>
        <span className="countdown-v3__lbl">{days === 1 ? "Dia" : "Dias"}</span>
      </div>
      <span className="countdown-v3__sep">:</span>
      <div className="countdown-v3__unit">
        <span className="countdown-v3__num">{zeroPad(hours)}</span>
        <span className="countdown-v3__lbl">{hours === 1 ? "Hora" : "Horas"}</span>
      </div>
      <span className="countdown-v3__sep">:</span>
      <div className="countdown-v3__unit">
        <span className="countdown-v3__num">{zeroPad(minutes)}</span>
        <span className="countdown-v3__lbl">Min</span>
      </div>
      <span className="countdown-v3__sep">:</span>
      <div className="countdown-v3__unit">
        <span className="countdown-v3__num">{zeroPad(seconds)}</span>
        <span className="countdown-v3__lbl">Seg</span>
      </div>
    </div>
  );
};

function LessonContent({
  course,
  videos_info,
  details,
  updateVideoCurrentTimeHandler,
  updateAudioCurrentTimeHandler,
  onVideoProgress,
  completeCtaVisible = true,
  lessonsStatus,
  updateLessonAsCompleted,
  refreshLessonsStatus,
  moveToNextLesson,
  isLastChapter,
  isLastLesson,
  courseAddedAt,
  courseEndDate,
  activeChapter,
  isSmallDevice,
}) {
  const [searchParams] = useSearchParams();
  const isIframeMode = searchParams.get("mode") === "iframe";

  // const [lessonAlmostCompleted, setLessonAlmostCompleted] = useState(false);
  const actualLessonCompleted = lessonsStatus?.find((el) => el.lesson_id === details?.lesson_id)?.completed || false;
  // const [showNextLessonButton, setShowNextLessonButton] = useState(false);

  // useEffect(() => {
  //   // setShowNextLessonButton(false);
  //  // setLessonAlmostCompleted(false);
  // }, [details]);

  const progressHandler = (currentTime, duration, ended, showButtonSecBefore = 8) => {
    // Forward real-time progress to an optional consumer (Flix "up next"). No-op for the
    // normal player, which never passes onVideoProgress.
    if (typeof onVideoProgress === "function") onVideoProgress(currentTime, duration, ended === true);

    if (ended === true) {
      setTimeout(() => {
        //  setShowNextLessonButton(true);
      }, 500);
      return;
    }

    // TODO: Implement view seconds on student account

    //  const _almostIs = currentTime >= duration - showButtonSecBefore;
    // if (_almostIs && !lessonAlmostCompleted) setLessonAlmostCompleted(true);
  };

  const _isChapterAvailable = (chapter, courseAddedAt, hasTeaserAccess = false) => {
    const chapterStatusCode = Number(chapter?.status_code);
    if (chapterStatusCode === 5 || chapterStatusCode === 6) return true;
    if (hasTeaserAccess === true && chapter?.teaser_locked === true) return false;
    if (chapterStatusCode === 0) return false;
    if (chapterStatusCode === 1) return true;

    // Dripping
    if (chapterStatusCode === 2 && chapter.drip_days !== undefined) {
      const avaliableDate = moment.utc(courseAddedAt).add(chapter.drip_days, "days");

      if (moment.utc().isAfter(avaliableDate)) return true;
    }

    // Avaliable On
    if (chapterStatusCode === 3 && chapter.avaliable_on !== undefined) {
      if (moment.utc().isAfter(chapter.avaliable_on)) return true;
    }

    return false;
  };

  const hasTeaserAccess = course?.teaser_access === true;
  const isChapterAvailable = _isChapterAvailable(activeChapter, courseAddedAt, hasTeaserAccess);

  if (details?.lesson_type === "video" && (isNil(details?.video_origin) || isNil(details?.video_source))) {
    return <NoVideo isMobile={isSmallDevice} />;
  }

  return (
    <>
      {isChapterAvailable === true && isSmallDevice !== true && (
        <div className="next-lesson">
          {details?.lesson_type !== "questionnaire" && actualLessonCompleted === false && completeCtaVisible && (
            <Button className="sp-lesson-cta" variant="contained" onClick={updateLessonAsCompleted}>
              <span style={{ marginRight: "10px" }}>Marcar aula como concluída</span> <CheckCircleOutline />
            </Button>
          )}
          {actualLessonCompleted === true && !isLastLesson && (
            <Button className="sp-lesson-cta" variant="contained" onClick={moveToNextLesson}>
              <span style={{ marginRight: "10px" }}>Ir para a próxima aula</span> <ChevronRight />
            </Button>
          )}
        </div>
      )}
      <div>
        {/* {isLastLesson && isChapterAvailable && (
        <div className="last-lesson">
          <Alert variant="filled" severity="success">
            <AlertTitle>
              <strong>Parabéns</strong>
            </AlertTitle>
            Já terminaste todas as aulas deste curso.
          </Alert>
        </div>
      )} */}
        {isChapterAvailable === true && details?.lesson_type === "text" && !details?.image && (
          <div style={{ paddingTop: isIframeMode ? 0 : "24px", marginBottom: "10px" }}>
            <DoesntContainVideo />
          </div>
        )}

        {!isChapterAvailable === true && (
          <div className="lesson-soon" id="lesson-container-soon" style={isIframeMode ? { marginTop: 50 } : undefined}>
            {activeChapter?.image !== null && activeChapter?.image !== undefined && (
              <div className="lesson-soon__cover" style={{ backgroundImage: `url("${activeChapter?.image}")` }}></div>
            )}
            <div className="lesson-soon__panel">
              <div className="lesson-state__icon">
                <ClockOutline />
              </div>
              <ChapterAvaliableIn
                chapter={activeChapter}
                courseAddedAt={courseAddedAt}
                courseEndDate={courseEndDate}
                hasTeaserAccess={hasTeaserAccess}
              />
            </div>
          </div>
        )}
        {isChapterAvailable === true && details?.lesson_type === "video" && details?.video_origin === "library" && (
          <VideoLibraryLesson
            course={course}
            videos_info={videos_info}
            details={details}
            updateVideoCurrentTimeHandler={updateVideoCurrentTimeHandler}
            progressHandler={progressHandler}
          />
        )}
        {isChapterAvailable === true && details?.lesson_type === "video" && details?.video_origin === "external" && (
          <VideoLesson
            course={course}
            videos_info={videos_info}
            details={details}
            updateVideoCurrentTimeHandler={updateVideoCurrentTimeHandler}
            progressHandler={progressHandler}
          />
        )}
        {isChapterAvailable === true && details?.lesson_type === "text" && (
          <TextLesson
            course={course}
            videos_info={videos_info}
            details={details}
            updateVideoCurrentTimeHandler={updateVideoCurrentTimeHandler}
            progressHandler={progressHandler}
          />
        )}
        {isChapterAvailable === true && details?.lesson_type === "audio" && (
          <AudioLesson details={details} updateAudioCurrentTimeHandler={updateAudioCurrentTimeHandler} progressHandler={progressHandler} />
        )}
        {isChapterAvailable === true && details?.lesson_type === "questionnaire" && (
          <Box
            sx={{
              width: 1,
              boxSizing: "border-box",
              px: { xs: 3, sm: 5, md: 8, lg: 10 },
              pt: { xs: 4, sm: 6, md: 8 },
              pb: { xs: 4, sm: 5, md: 6 },
            }}
          >
            <QuestionnaireLesson
              courseId={course?.course_id}
              lessonId={details?.lesson_id}
              lessonCompleted={actualLessonCompleted}
              onQuestionnaireSubmitSuccess={refreshLessonsStatus ?? updateLessonAsCompleted}
            />
          </Box>
        )}
      </div>
      {isChapterAvailable === true && isSmallDevice === true && (
        <div className="next-lesson-small-device">
          {details?.lesson_type !== "questionnaire" && actualLessonCompleted === false && completeCtaVisible && (
            <Button className="sp-lesson-cta" variant="contained" onClick={updateLessonAsCompleted}>
              <span style={{ marginRight: "10px" }}>Marcar aula como concluída</span> <CheckCircleOutline />
            </Button>
          )}
          {actualLessonCompleted === true && !isLastLesson && (
            <Button className="sp-lesson-cta" variant="contained" onClick={moveToNextLesson}>
              <span style={{ marginRight: "10px" }}>Ir para a próxima aula</span> <ChevronRight />
            </Button>
          )}
        </div>
      )}
    </>
  );
}

export default LessonContent;
